export const ROUTES = {
  DASHBOARD: "/dashboard",
  PAYOUTS: "/payouts",
  CONTRACTORS: "/contractors",
  CONTRACTOR_DETAIL: "/contractors/:uuid",
  CLIENTS: "/clients",
  CLIENT_DETAIL: "/clients/:uuid",
  DISCOUNTS: "/discounts",
  DISCOUNT_NEW: "/discounts/new",
  DISCOUNT_DETAIL: "/discounts/:uuid",
  DISCOUNT_USAGES: "/discounts/:uuid/usages",
  FEEDBACK: "/feedback",
  FEEDBACK_SETTINGS: "/feedback/settings",
  GAS_STATIONS: "/gas-stations",
  HELP: "/help",
  HELP_SETTINGS: "/help/settings",
  AUTH_PHONE: "/auth/phone",
  AUTH_CODE: "/auth/code",
  NOT_FOUND: "/404",
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = (typeof ROUTES)[RouteKey];

export function discountDetailPath(uuid: string): string {
  return ROUTES.DISCOUNT_DETAIL.replace(":uuid", uuid);
}

export function discountUsagesPath(uuid: string): string {
  return ROUTES.DISCOUNT_USAGES.replace(":uuid", uuid);
}
